export function formatDate(dateString) {
  let normalized = dateString.replace(" ", "T");

  let d = new Date(normalized);
  if (isNaN(d)) return dateString;
  return new Intl.DateTimeFormat("fr-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(d);
}
